// Schwellwerte für die Inaktivitäts-Warnung („Rotting", Pipedrive-Muster).
// Ab HINT: dezenter Hinweis (Bernstein), ab WARN: deutliche Warnung (Rot).
// Zurückgesetzt wird nur durch echte Aktivität (Notiz/E-Mail/Anruf geloggt,
// Aufgabe erledigt, Phasenwechsel) — bloß geplante Zukunfts-Aufgaben zählen nicht.
// FALLBACK (seit B3): maßgeblich sind die Werte aus /pipeline-config/
// (global + je Phase überschreibbar), bezogen über den PipelineConfigProvider.
export const STALE_HINT_DAYS = 7;
export const STALE_WARN_DAYS = 14;

// Kuratierte Verlustgründe (auswertbar statt Freitext).
// FALLBACK (seit B3): maßgeblich ist die im Admin gepflegte LostReason-Liste
// aus /pipeline-config/; „Sonstiges" erlaubt weiterhin Freitext.
export const LOST_REASONS = [
  'Preis zu hoch',
  'Kein Budget',
  'Zeitpunkt unpassend',
  'An Wettbewerber verloren',
  'Kein Bedarf / keine Passung',
  'Kontakt nicht erreichbar',
  'Anforderungen nicht erfüllbar',
  'Intern gelöst',
];
export const LOST_REASON_OTHER = 'Sonstiges';
